// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { CypressFields } from '../../utils/Cypress';
import { Product } from '../../protos/demo';
import ProductPrice from '../ProductPrice';
import * as S from './ProductCard.styled';
import { useState, useEffect } from 'react';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { getImageWithDelay } from '../../utils/DelayedImage';
import SessionGateway from '../../gateways/Session.gateway';

interface IProps {
  product: Product;
}

const ProductCard = ({
  product: {
    id,
    picture,
    name,
    priceUsd = {
      currencyCode: 'USD',
      units: 0,
      nanos: 0,
    },
  },
}: IProps) => {

  const { geography, device } = SessionGateway.getSession();
  const slowLoadEnabled = useBooleanFlagValue('imageSlowLoad', false);
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    if(picture){
      getImageWithDelay(picture, slowLoadEnabled).then(blob => {
        setImageSrc(URL.createObjectURL(blob));
      });
    }
  }, [picture, slowLoadEnabled]);

  return (
    <S.Link href={`/product/${id}?device=${device}&geography=${geography}`}>
      <S.ProductCard data-cy={CypressFields.ProductCard}>
        <S.Image $src={imageSrc} />
        <div>
          <S.ProductName>{name}</S.ProductName>
          <S.ProductPrice>
            <ProductPrice price={priceUsd} />
          </S.ProductPrice>
        </div>
      </S.ProductCard>
    </S.Link>
  );
};

export default ProductCard;
